import { BACKEND_URL } from "../../utils/config";
import { errorHandler } from "../../utils/error_handler";
import { getUserPermission } from "../../utils/getUserPermission";

export const setGetTags = (data) => ({
  type: "SET_GET_TAGS",
  payload: data,
  request_time: Date.now(),
});

export const setUpdateTags = (data) => ({
  type: "SET_UPDATE_TAGS",
  payload: data,
  request_time: Date.now(),
});

export const setDeleteTags = (data) => ({
  type: "SET_DELETE_TAGS",
  payload: data,
  request_time: Date.now(),
});

export const setCreateTags = (data) => ({
  type: "SET_CREATE_TAGS",
  payload: data,
  request_time: Date.now(),
});

export const getTags = () => {
  return (dispatch, getState) => {
    const state = getState();
    try {
      if (!getUserPermission(state, "initypes", "list", true)) {
        throw new Error("No permissions");
      }
      if (
        state.initypes.request_time === null ||
        state.initypes.request_time + 1000 * 2 < Date.now()
      ) {
        fetch(`${BACKEND_URL}/tags`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.sessions.token}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else {
              throw new Error(response.status);
            }
          })
          .then((data) => {
            dispatch(setGetTags(data));
          })
          .catch((error) => {
            errorHandler("initypes", error.message);
            dispatch(setGetTags(error));
          });
      }
    } catch (error) {
      errorHandler("initypes", error.message);
      dispatch(setGetTags(error));
    }
  };
};

export const createTags = (data) => {
  return (dispatch, getState) => {
    const state = getState();
    try {
      if (!getUserPermission(state, "initypes", "create")) {
        throw new Error("No permissions");
      }
      fetch(`${BACKEND_URL}/tags`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.sessions.token}`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status === 201) {
            return response.json();
          } else {
            throw new Error(response.status);
          }
        })
        .then((data) => {
          if (data != null && data !== undefined ) {
            dispatch(setCreateTags(data));
          }
        })
        .catch((error) => {
          errorHandler("tags", error.message);
          dispatch(setCreateTags(error));
        });
    } catch (error) {
      errorHandler("tags", error.message);
      dispatch(setCreateTags(error));
    }
  };
};

export const updateTag = (data) => {
  return (dispatch, getState) => {
    const state = getState();
    try {
      if (!getUserPermission(state, "initypes", "create")) {
        throw new Error("No permissions");
      }
      fetch(`${BACKEND_URL}/tags/${data.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.sessions.token}`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error(response.status);
          }
        })
        .then((data) => {
          dispatch(setUpdateTags(data));
        })
        .catch((error) => {
          errorHandler("tags", error.message);
          dispatch(setUpdateTags(error));
        });
    } catch (error) {
      errorHandler("tags", error.message);
      dispatch(setUpdateTags(error));
    }
  };
};

export const deleteTag = (id) => {
  return (dispatch, getState) => {
    const state = getState();
    try {
      if (!getUserPermission(state, "initypes", "delete")) {
        throw new Error("No permissions");
      }
      fetch(`${BACKEND_URL}/tags/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.sessions.token}`,
        },
      })
        .then((response) => {
          if (response.status === 204) {
            return true
          } else {
            throw new Error(response.status);
          }
        })
        .then((data) => {
          dispatch(setUpdateTags(data));
        })
        .catch((error) => {
          console.log(error);
          errorHandler("tags", error.message);
          dispatch(setUpdateTags(error));
        });
    } catch (error) {
      errorHandler("tags", error.message);
      dispatch(setUpdateTags(error));
    }
  };
};
